import { KYMW1312Model } from '../kymw1312.model';
import { KYMW1312RegistSetPlanPromotionGoodsModel } from '../vo/kymw1312-regist-set-plan-promotion-goods.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * セット企画設定画面　プロモーション商品情報を登録するサービス
 *
 * @export RegistSetPlanPromotionGoodsService
 * @class RegistSetPlanPromotionGoodsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistSetPlanPromotionGoodsService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1312Model}
   * @memberof RegistSetPlanPromotionGoodsService
   */
  private model: KYMW1312Model;

  /**
   * 処理に使用するvo
   *
   * @private
   * @type {KYMW1312RegistSetPlanPromotionGoodsModel}
   * @memberof RegistSetPlanPromotionGoodsService
   */
  private vo: KYMW1312RegistSetPlanPromotionGoodsModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistSetPlanPromotionGoodsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        SetPromotionGoods: {
          condition: {
            PromotionNo: this.vo.promotionNo,
            PromotionDiv: this.vo.promotionDiv,
            OrderCode: this.vo.orderCode,
            PromotionName: this.vo.promotionName
          },
          combination: this.vo.registGoodsList.map(goods => {
            return {
              condition: {
                PCode: goods.pCode,
                MediumType: goods.mediumType,
                CoopCode: goods.coopCode,
                SetDelivGoodsName: goods.setDelivGoodsName,
                SetDelivGoodsNameKana: goods.setDelivGoodsNameKana,
                SetDelivStandardName: goods.setDelivStandardName,
                SetDelivStandardNameKana: goods.setDelivStandardNameKana,
                SetPlanDiv: goods.setPlanDiv,
                SingleOrderFlag: goods.singleOrderFlag,
                AcceptDiv: goods.acceptDiv,
                SupplyDiv: goods.supplyDiv,
                ApprovedNum: goods.approvedNum,
                ApprovedPrice: goods.approvedPrice
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof RegistSetPlanPromotionGoodsService
   */
  execute(model: any, vo: any): void {
    this.model = <KYMW1312Model>model;
    this.vo = vo;
    this.send('registSetPlanPromotionGood', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistSetPlanPromotionGoodsService
   */
  success(data: any): void {
    // 呼出元画面の再表示を行う
    this.model.KYMW1312Component.refleshKYMW1300();

    // プロモーションＮＯ再取得
    this.model.KYMW1312Component.refleshPromotionNo();
  }
}
